import { render, staticRenderFns } from "./QRCodeGenerator.vue?vue&type=template&id=208c0ab4&scoped=true"
import script from "./QRCodeGenerator.vue?vue&type=script&lang=js"
export * from "./QRCodeGenerator.vue?vue&type=script&lang=js"
import style0 from "./QRCodeGenerator.vue?vue&type=style&index=0&id=208c0ab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208c0ab4",
  null
  
)

export default component.exports